export default __webpack_public_path__ + "media/Bitbucket_right.38794cd16f8b73abcd9fdac9b838f4f0.svg";